//prefix: page that the button resides+_
export default ({ prefix, btnString, gtag, extraInfo }) => {
  gtag('event', `Clicked`, {
    event_category: 'Buttons',
    event_label: `${prefix}${btnString}${extraInfo ? '_' + extraInfo : ''}`,
  })
}
